import React, { useState } from 'react'
import MyNavbar from '../components/MyNavbar'
import Footer from '../components/Footer'
import ScrollableBox from '../components/TextInfo'
import FAQ from '../components/FAQ'
import { Col, Container, Row } from 'react-bootstrap'
import detailImg from '../assests/detail.png'
import selectWriter from '../assests/select writer.png'
import payment from '../assests/payment.png'

export default function HowItWorks() {
  const [image , setImage ] = useState(detailImg);


  return (
    <div>
      <MyNavbar/>
      <section className='footerbg'>
       <Container>
        <Row className='d-flex justify-content-center align-items-center p-4' style={{minHeight:'500px'}}>
          <Col className='mt-4 mb-4'>
          <img src={detailImg} alt="" className='w-100 rounded-3 shadow-lg img-thumbnail'/>
          </Col>
          <Col></Col>
        </Row>
       </Container>

      </section>
      <section className=''>
       <Container>
        <Row className='p-4'>
          <Col>
          <img src={selectWriter} alt="" className='w-100' />
          </Col>
          <Col>cd</Col>
        </Row>
       </Container>

      </section>
      <section className='footerbg'>
       <Container>
        <Row className='p-4'>
          <Col><img src={payment} alt="" className='w-100' /></Col>
          <Col>cd</Col>
        </Row>
       </Container>

      </section>
      <section className=''>
       <Container>
        <Row>
          <Col><h1>ab</h1></Col>
          <Col>cd</Col>
        </Row>
       </Container>

      </section>
      
      <section>
        <FAQ/>
      </section>
      <section>
        <ScrollableBox/>
      </section>
      <Footer/>
    </div>
  )
}
